import { Grid } from '@material-ui/core';
import ToolTip from '@material-ui/core/Tooltip';
import Icon from '../../Icon';
import Handle from '../../Handler';
import './style.css';
import { makeStyles } from '@material-ui/core/styles';
import { internalSystem } from "../../../../../../../config/common";
import helpers from '../../../helpers';
import { nodeKeysLabel } from "../../../../../../../config/common";
import { useDispatch, useSelector } from 'react-redux';
import NodeHelperPopup from '../../../../../dialogs/NodeHelperPopup';


const useStyles = makeStyles({
    image: {
        width: 77,
        height: 70,
        display: 'block',
        position: 'relative',
        top: 0,
        left: 17,
        marginTop: 15
    },
    label: {
        textAlign: 'right',
        color: '#000',
        display: 'block',
        fontSize: 17,
        fontFamily: 'Roboto, Helvetica',
        fontWeight: 500,
        position: 'relative',
    },
    labelDiv: {
        marginTop: "130px",
        pointerEvents: 'all'
    }
})


export default function Sensor({ props, iconStyle }) {
    const nodeData = props.data != undefined ? props.data : '';
    const title = props?.data?.subType !== undefined && props?.data?.subType !== '' ? nodeKeysLabel[props?.data?.subType] : helpers.nodeKeysLabel[props.type];
    const nodeTitle = props?.data?.label || null;
    const classes = useStyles();
    const isNodeRight = props.xPos > (internalSystem.position.x + internalSystem.style.width);
    return (
        <Grid row id={`node-${props?.id}`}>
            {/* <ToolTip title={<>{nodeData?.label}<br />{`(${title})`}</>} > */}
                <Grid xs={12} container spacing={2} style={{pointerEvents: 'all'}}>
                    <Icon icon={props?.data?.icon} metaData={props.data} isCustomIcon={props?.data?.isCustomIcon} defaultIcon={'ide_sensor_default'} style={iconStyle} />
                {nodeData?.showHelper && <NodeHelperPopup nodeData={nodeData} title={title} nodeId={props.id} nodeType={props.type} subType={props?.data?.subType} templateId={props?.templateId} />}
                
                </Grid>
            {/* </ToolTip> */}

            <Grid item xs={12} className={classes.labelDiv}><span className={classes.label}>{props.data.label}</span></Grid>

            <Handle type="source" position={isNodeRight ? 'left' : 'right'} id={isNodeRight ? 'left' : 'right'} node={props}/>
        </Grid>
    )
}